export default __webpack_public_path__ + "static/media/TUSD.215c1692.svg";